import DashboardLayout from "@/layout/dashboard/DashboardLayout.vue";
import AuthLayout from "@/layout/AuthLayout.vue";
// GeneralViews
import Login from "@/pages/Login.vue";
import NotFound from "@/pages/NotFoundPage.vue";

// Admin pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */"@/pages/Dashboard.vue");
const Criteria = () => import(/* webpackChunkName: "common" */ "@/pages/Criteria.vue");
const Companies = () => import(/* webpackChunkName: "common" */ "@/pages/Companies.vue");
const Industries = () => import(/* webpackChunkName: "common" */ "@/pages/Industries.vue");
const Reports = () => import(/* webpackChunkName: "common" */ "@/pages/Reports.vue");
const Company = () => import(/* webpackChunkName: "common" */ "@/pages/Company.vue");
// const Profile = () => import(/* webpackChunkName: "common" */ "@/pages/Profile.vue");
// const Notifications = () => import(/* webpackChunkName: "common" */"@/pages/Notifications.vue");
// const Icons = () => import(/* webpackChunkName: "common" */ "@/pages/Icons.vue");
// const Maps = () => import(/* webpackChunkName: "common" */ "@/pages/Maps.vue");
// const Typography = () => import(/* webpackChunkName: "common" */ "@/pages/Typography.vue");
// const TableList = () => import(/* webpackChunkName: "common" */ "@/pages/TableList.vue");

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    meta: {
      requiresAuth: true,
      requiresActions: ['prism_access']
    },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: Dashboard
      },
      {
        path: "criteria",
        name: "criteria",
        component: Criteria
      },
      {
        path: "companies",
        name: "companies",
        component: Companies
      },
      {
        path: "industries",
        name: "industries",
        component: Industries
      },
      {
        path: "reports",
        name: "reports",
        component: Reports
      },
      {
        path: "/companies/:companyId",
        name: "company",
        component: Company,
      },
      // {
      //   path: "profile",
      //   name: "profile",
      //   component: Profile
      // },
      // {
      //   path: "notifications",
      //   name: "notifications",
      //   component: Notifications
      // },
      // {
      //   path: "icons",
      //   name: "icons",
      //   component: Icons
      // },
      // {
      //   path: "maps",
      //   name: "maps",
      //   component: Maps
      // },
      // {
      //   path: "typography",
      //   name: "typography",
      //   component: Typography
      // },
      // {
      //   path: "table-list",
      //   name: "table-list",
      //   component: TableList
      // }
    ]
  },
  {
    path: "/",
    redirect: "login",
    component: AuthLayout,
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
      }
    ],
  },
  { path: "*", component: NotFound },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes;
